import { Button, Col, Form, Row } from 'react-bootstrap';
import { UserSelector } from '../../../common/components/selectors/user/UserSelector';
import { EmployeeSelector } from '../../../common/components/selectors/employee/EmployeeSelector';
import { AUDITABLE_ENTITY_OPTIONS } from '../models/auditLog.model';

export interface AuditLogsFiltersValues {
  entityName: string;
  primaryKey: string;
  startDate: string;
  endDate: string;
  userId: string | null;
  employeeId: string | null;
  operation: string;
  correlationId: string;
}

interface Props {
  values: AuditLogsFiltersValues;
  onChange: (next: AuditLogsFiltersValues) => void;
  onApply: () => void;
  onClear: () => void;
  disabled?: boolean;
  validationMessage?: string;
}

const OPERATION_OPTIONS = [
  { value: '', label: 'Cualquiera' },
  { value: '0', label: 'Crear' },
  { value: '1', label: 'Actualizar' },
  { value: '2', label: 'Eliminar' },
];

export function AuditLogsFilters({
  values,
  onChange,
  onApply,
  onClear,
  disabled,
  validationMessage,
}: Props) {
  return (
    <>
      {validationMessage && (
        <div className="alert alert-warning py-2 small mb-2" role="alert">
          {validationMessage}
        </div>
      )}
      <Row className="g-2 align-items-end mb-2">
        <Col md={4}>
          <Form.Label className="small text-muted mb-1">Entidad</Form.Label>
          <Form.Select
            value={values.entityName}
            disabled={disabled}
            onChange={(e) => onChange({ ...values, entityName: e.target.value })}
          >
            <option value="">Todas</option>
            {AUDITABLE_ENTITY_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Select>
        </Col>

        <Col md={3}>
          <UserSelector
            id="userId"
            onChange={onChange}
            value={values.userId}
            label="Usuario"
            disabled={disabled}
            values={values}
          />
        </Col>

        <Col md={3}>
          <EmployeeSelector
            id="employeeId"
            onChange={onChange}
            value={values.employeeId}
            label="Empleado"
            disabled={disabled}
            values={values}
          />
        </Col>

        <Col md={2}>
          <Form.Label className="small text-muted mb-1">Operación</Form.Label>
          <Form.Select
            value={values.operation}
            disabled={disabled}
            onChange={(e) => onChange({ ...values, operation: e.target.value })}
          >
            {OPERATION_OPTIONS.map((o) => (
              <option key={o.value || 'any'} value={o.value}>
                {o.label}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="g-2 align-items-end mb-3">
        <Col md={3}>
          <Form.Label className="small text-muted mb-1">Fecha desde</Form.Label>
          <Form.Control
            type="date"
            value={values.startDate}
            disabled={disabled}
            onChange={(e) => onChange({ ...values, startDate: e.target.value })}
          />
        </Col>
        <Col md={3}>
          <Form.Label className="small text-muted mb-1">Fecha hasta</Form.Label>
          <Form.Control
            type="date"
            value={values.endDate}
            disabled={disabled}
            onChange={(e) => onChange({ ...values, endDate: e.target.value })}
          />
        </Col>
        <Col md={6}>
          <Form.Label className="small text-muted mb-1">Correlation id (GUID)</Form.Label>
          <Form.Control
            type="text"
            placeholder="Opcional"
            value={values.correlationId}
            disabled={disabled}
            onChange={(e) => onChange({ ...values, correlationId: e.target.value })}
          />
        </Col>
      </Row>
      <Row className="g-2 mb-2">
        <Col xs="auto">
          <Button variant="primary" disabled={disabled} onClick={onApply}>
            <i className="ri-filter-3-line me-1" />
            Aplicar filtros
          </Button>
        </Col>
        <Col xs="auto">
          <Button variant="outline-secondary" disabled={disabled} onClick={onClear}>
            <i className="ri-close-line me-1" />
            Limpiar filtros
          </Button>
        </Col>
      </Row>
    </>
  );
}
